import React, { useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Row, FormInstance, Spin, Input, Tabs, DatePicker } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';

import UtinaCard from 'components/UtinaCard';

import Text from 'antd/lib/typography/Text';
import TextArea from 'antd/lib/input/TextArea';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toDatePickerDate } from 'utils/utils2';
import { useGetAssetDetails } from 'pages/Asset/AssetDetail/useGetAssetDetails';

const { TabPane } = Tabs;

export type TabUpdateAssetRegistrationDataProps = {
  form?: FormInstance;
  objectid?: number;
  dataInput?: any;
  setSuccessful?: any;
  object?: string;
};

const TabUpdateAssetRegistrationData = ({
  objectid,
  form,
  dataInput,
  setSuccessful,
  object,
}: TabUpdateAssetRegistrationDataProps) => {
  const [state, setState] = useState<any>({
    attid: 0,
    assetfamily: { value: '', label: '' },
    assettype: { value: '', label: '' },
    assetcategory: { value: '', label: '' },
  });

  const {
    data: asset,
    refetch,
    isFetching,
  } = useGetAssetDetails(objectid, object === 'FINASSET' ? 'PROD' : 'PROPOSAL');



  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    setSuccessful(isFetching);
    if (asset) {
      form?.setFieldsValue({
        ...asset,
        assetmodel: {
          value: asset?.assetmodel ?? '',
          label: asset?.assetmodellabel ?? asset?.assetmodel ?? '',
        },
        assettaggrouping: asset?.assettaggrouping,
        assetsegment: asset?.assetsegment,
        assetcategorylabel: asset?.assetcategorylabel,
        assetfamily: {
          value: asset?.assetfamily ?? '',
          label: asset?.assetfamilylabel ?? '',
        },
        assettypelabel: asset?.assettypelabel,
        assettype: { value: asset?.assettype, label: asset?.assettypelabel },

        assetcategory: {
          value: asset?.assetcategory,
          label: asset?.assetcategorylabel,
        },

        assetconstructor: asset?.assetconstructor,
        assetdeliverydate: toDatePickerDate(asset?.assetdeliverydate),
        assetdeliveryreference: asset?.assetdeliveryreference,
        assetexpdeliverydate: toDatePickerDate(asset?.assetexpdeliverydate),
        assetdescription: asset?.assetdescription,
        assetid: asset?.assetid,
        assetlabel: asset?.assetlabel,

        assetreference: asset?.assetreference,
        assetstatus: asset?.assetstatus,
        statuslabel: asset?.assetstatusdate
          ? asset?.statuslabel + ' (' + asset?.assetstatusdate + ')'
          : asset?.statuslabel,
        status: asset?.assetstatus,

        chassisno: asset?.chassisno,
        engineno: asset?.engineno,
        plateno: asset?.plateno,
        power: asset?.power,
        registrationno: asset?.registrationno,
        registrationcity: asset?.registrationcity,
        registrationdate: toDatePickerDate(asset?.registrationdate),
        registrationname: asset?.registrationname,
        firstregistrationdate: toDatePickerDate(asset?.firstregistrationdate),
        fiscalpower: asset?.fiscalpower,
        serialno: asset?.serialno,
        weight: asset?.weight,
        supplier: {
          tpid: asset?.tpidsupplier,
          tpreference: asset?.supplierreference,
          tpname: asset?.suppliername,
        },

        assetpictureurl: asset?.assetpictureurl,
        event: 'tabUpdateAssetRegistrationData',
      });
      setState({
        attid: 0,
        assetsegment: asset?.assetsegment,
        assetfamily: {
          value: asset?.assetfamily,
          label: asset?.assetfamilylabel ?? '',
        },
        assettype: { value: asset?.assettype, label: asset?.assettypelabel },
        assetcategory: {
          value: asset?.assetcategory,
          label: asset?.assetcategorylabel,
        },
      });
    }
  }, [asset]);

  return (
    <DF.Provider pagcode="tabUpdateAssetRegistrationData">
      <Spin spinning={isFetching}>
        <Tabs animated defaultActiveKey="1">
          <TabPane tab={<GetLabel label="Assets" />} key={1} forceRender>
            <Row>
              <UtinaCard
                level={5}
                comcode="assetGeneralInformation"
                style={{ color: '#000' }}
                lg={11}
                additionalAttribute
              >
                <FormInput
                  col
                  lg={10}
                  name="assetreference"
                  comcode="assetreference"
                >
                  <Text>{asset?.assetreference}</Text>
                </FormInput>
                <FormInput name="statuslabel" col xs={12}>
                  <Text>{asset?.statuslabel}</Text>
                </FormInput>
                <FormInput
                  col
                  md={24}
                  name="assetlabel"
                  comcode="assetlabel"
                  rules={[{ required: true }]}
                >
                  <Input defaultValue={asset?.assetlabel} disabled></Input>
                </FormInput>

                <FormInput name="assetsegmentlabel" col xs={10}>
                  <Text>{asset?.assetsegmentlabel}</Text>
                </FormInput>
                <FormInput name="assetfamilylabel" col xs={12}>
                  <Text>{asset?.assetfamilylabel}</Text>
                </FormInput>
                <FormInput name="assettypelabel" col xs={10}>
                  <Text>{asset?.assettypelabel}</Text>
                </FormInput>
                <FormInput name="assetcategorylabel" col xs={12}>
                  <Text>{asset?.assetcategorylabel}</Text>
                </FormInput>
                <FormInput name="assetmodellabel" col xs={10}>
                  <Text>{asset?.assetmodel}</Text>
                </FormInput>
                <FormInput col xs={24} name="assetdescription">
                  <TextArea
                    rows={3}
                    maxLength={500}
                    defaultValue={asset?.assetdescription}
                    disabled
                  ></TextArea>
                </FormInput>
              </UtinaCard>

              <UtinaCard
                level={5}
                comcode="registrationInfo"
                style={{ color: '#000', padding: 15 }}
                lg={11}
              >
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="serialno"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>
                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="registrationno"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="plateno"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="registrationdate"
                    rules={[{ required: false }]}
                  >
                    <DatePicker />
                  </FormInput>
                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="chassisno"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="registrationname"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>
                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="engineno"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="registrationcity"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="fiscalpower"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>

                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="firstregistrationdate"
                    rules={[{ required: false }]}
                  >
                    <DatePicker />
                  </FormInput>
                  <FormInput
                    col
                    xs={12}
                    md={12}
                    name="weight"
                    rules={[{ required: false }]}
                  >
                    <Input />
                  </FormInput>
                </Row>
              </UtinaCard>
            </Row>
          </TabPane>
        </Tabs>
      </Spin>
    </DF.Provider>
  );
};
export default TabUpdateAssetRegistrationData;
